export default {"src":"/_next/static/media/community.4e486030.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};